import { getAuth } from 'firebase/auth';
import { getRemoteConfig } from 'firebase/remote-config';
import { v4 as uuidv4 } from 'uuid';

import { apiClient, fetchBaseUrl } from '../../api/tools/tools';

const readCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

const hasMarketingConsent = () => readCookie('im_cookie_consent') === 'granted';

export const trackPixel = (event, params, options) => {
  window.fbq?.('track', event, params, options);
};

// Pixel params use Meta's snake_case names; the API takes the same values in camelCase
const toServerParams = (params = {}) => ({
  value: params.value,
  currency: params.currency,
  contentIds: params.content_ids,
  contentName: params.content_name,
  contentType: params.content_type,
  numItems: params.num_items,
  searchString: params.search_string
});

const sendServerEvent = async (body) => {
  try {
    const token = await getAuth().currentUser?.getIdToken();
    const url = `${await fetchBaseUrl(getRemoteConfig())}/meta/events`;
    await apiClient.post(url, body, token ? { headers: { Authorization: `Bearer ${token}` } } : {});
  } catch {
    // Tracking must never break the shop
  }
};

/**
 * Sends the event from the browser pixel and, with consent, from the server through the
 * Conversions API. Both share one event id so Meta counts it once. `customer` carries details
 * the browser already has (email, phone, name, address) to improve matching.
 */
export const trackEvent = (event, params = {}, customer = {}) => {
  const eventId = uuidv4();
  trackPixel(event, params, { eventID: eventId });

  if (!hasMarketingConsent()) return;

  sendServerEvent({
    eventName: event,
    eventId,
    eventSourceUrl: window.location.href,
    marketingConsent: true,
    fbp: readCookie('_fbp'),
    fbc: readCookie('_fbc'),
    ...toServerParams(params),
    ...customer
  });
};

// Sent with the order so the backend can send a matching Purchase via the Conversions API
export const getPixelOrderContext = () => ({
  marketingConsent: hasMarketingConsent(),
  metaFbp: readCookie('_fbp'),
  metaFbc: readCookie('_fbc')
});
